class FilteredTextField {
    constructor(element, quickDeleteAreaElement, filterData, options) {
        this.filterData = filterData;
        this.entries = filterData.options;

        this.entries = this.entries.filter(function(element){
            if(element.hasOwnProperty('startDate')){
                let startDate = new Date(element.startDate);
                startDate.setDate(startDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionStartDateOffset', 0));  
                let now = new Date();

                if(startDate > now)
                    return false;
            }

            if(element.hasOwnProperty('expiryDate')){
                let endDate = new Date(element.expiryDate);
                endDate.setDate(endDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionEndDateOffset', 0));
                let now = new Date();

                if(now >= endDate)
                    return false;
            }

            return true;
        });

        if(this.entries.length > 0 && !this.entries[0].hasOwnProperty('name') && this.entries[0].hasOwnProperty('value'))
        {
            let entries = this.entries.map( x => {
                x.name = x.value;
                return x
                });

                this.entries = entries;
        }

        this.defaultOptions = {
            multiSelect: true,
            showSelectionCount: true,
            showZeroSelectionCount: false,
            showResults: true,
            maxItems: 15,
            maxHeight: (16 * 39 + 20),
            allowSearchTerms: true,
            backgroundImagePadding: 0,
            showClearAllButton: true,
            hideEntriesWithZeroResults: true,
            itemPaddingTopBottom : 12,
            quickDeleteHeight: 30,
            quickDeletePadding: '5px 10px',
            localOnly: false,
            width:"auto",
            buttonTopBottomPadding: 10
        }
        
        this.options = Object.assign({}, this.defaultOptions, options);
        this.allowedEntries = null;
        this.uid = this.uuidv4();
        this.parentElement = element;
        this.quickDeleteAreaElement = quickDeleteAreaElement;
        this.parentElement.setAttribute('data-filtered-dropdown-id', this.uid);
        this.filtered = false;
        this.selectedItems = [];

        window[this.uid] = this;


        document.addEventListener('click', (event) => {
            const withinBoundaries = event.composedPath().includes(this.wrapper)

            if (!withinBoundaries) {
                this.hideDropdown();
            }
        })
        this.buildUI();

    }

    show(style) {
        this.parentElement.style.display = (style || 'block');
    }


    hide() {
        this.parentElement.style.display = 'none';
    }

    getTranslation(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Translation.get(key, defaultValue);
        } else {
            return defaultValue
        }
    }

    getBooleanTheme(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Theme.getBooleanProperty(key, defaultValue);
        } else {
            return defaultValue
        }
    }

    getIntTheme(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Theme.getIntegerProperty(key, defaultValue);
        } else {
            return defaultValue
        }
    }


    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    htmlToElement(html) {
        let template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    getTranslatedLabel(item){
        if(!item.hasOwnProperty('label'))
            return '';
        
        let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
        
        if(!item.hasOwnProperty('translations') || item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0) == -1){
            return item.label;
        }
        
        let index = item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0);
        
        if(index < 0)
            return item.label;
    
        return item.translations[index].label || item.label;
    }

    buildUI() {
        let width = this.options.width;
        this.wrapper = this.htmlToElement("<div class='filteredDropdown' style='width:"+width+"' id='" + this.uid + "MainWrapper'></div>");
      
        this.headerDiv = this.htmlToElement("<input data-filtered-textfield='"+this.uid+"' id='"+this.filterData.name+"' onfocus='this.blur();' name='"+this.filterData.name+"' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' onclick='window[\"" + this.uid + "\"].toggleDropdown()' class='' placeHolder='"+this.getTranslation('optionSelectLabel', 'Please select an option') +"' />");
        this.dropdownContent = this.htmlToElement("<div style='width:"+width+"' class='filteredDropdown-content'></div>");
        this.searchInput = this.htmlToElement('<input type="text" placeholder="' + this.getTranslation('searchFiltersPlaceholder', 'Search...') + '" class="filteredDropdownSearchInput" oninput="window[\'' + this.uid + '\'].filterItems()">');
        this.resultsText = this.htmlToElement('<span class="resultsText"></span>')
        this.loadingWheel = this.htmlToElement('<div class="loading-wheel"><div class="lds-roller filters"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>');
        this.dropdownItems = this.htmlToElement('<div class="filteredDropdown-items" style="max-height:' + this.options.maxHeight + 'px"></div>');
        this.clearAllButton = this.htmlToElement("<div onclick='window[\"" + this.uid + "\"].clearAllSelected(true)' class='clearAllButton'>" + this.getTranslation('filterClearAllOption', 'Clear All') + "</div>");

        this.dropdownContent.appendChild(this.searchInput);
        this.dropdownContent.appendChild(this.loadingWheel);
        this.dropdownContent.appendChild(this.dropdownItems);
        if (this.options.showClearAllButton) {
            this.dropdownContent.appendChild(this.clearAllButton);
        }
        this.dropdownContent.appendChild(this.resultsText);


        this.resultsText.style.display = 'none';

        this.wrapper.appendChild(this.headerDiv);
        this.wrapper.appendChild(this.dropdownContent);

        this.parentElement.appendChild(this.wrapper);

        this.renderEntries(this.entries);
    }

    hideAllDropdowns(){
        //Only show one at a time
        if (!this.headerDiv.classList.contains('filteredDropdownActive')) {
            let nodeList = document.querySelectorAll('.filteredDropdownActive');
            let i;
            for (i = 0; i < nodeList.length; i++) {
                nodeList[i].classList.remove('filteredDropdownActive');
            }
        }
    }

    /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
    toggleDropdown() {
        //Only show one at a time
        if (!this.dropdownContent.classList.contains('filteredDropdownShow')) {
            let nodeList = document.querySelectorAll('.filteredDropdownShow');
            let i;
            for (i = 0; i < nodeList.length; i++) {
                nodeList[i].classList.remove('filteredDropdownShow');
            }
        }

        this.hideAllDropdowns();

        
        this.dropdownContent.classList.toggle("filteredDropdownShow");
        this.headerDiv.classList.toggle("filteredDropdownActive");
        this.allowedEntries = null;
        this.searchInput.focus();
        this.renderEntries(this.entries);

        
    }

    hideDropdown() {
        this.dropdownContent.classList.remove("filteredDropdownShow");
        this.headerDiv.classList.remove("filteredDropdownActive");
    }

    filterItems() {
        let filter, a, i;
        filter = this.searchInput.value.toUpperCase();

        let startsWith = false;
        let endsWith = false;
        let showSelected = false;
        let showEmpty = false;
        
        if (this.options.allowSearchTerms && filter.startsWith('STARTSWITH:')) {
            filter = filter.replace('STARTSWITH:', '');
            startsWith = true;
        } else if (this.options.allowSearchTerms && filter.startsWith('ENDSWITH:')) {
            filter = filter.replace('ENDSWITH:', '');
            endsWith = true;
        } else if (this.options.allowSearchTerms && filter.startsWith('SELECTED:')) {
            filter = filter.replace('SELECTED:', '');
            showSelected = true;
        }   else if (this.options.allowSearchTerms && filter.startsWith('SHOWEMPTY:')) {
            filter = filter.replace('SHOWEMPTY:', '');
            showEmpty = true;
        } 


        if(showEmpty){
            this.filtered = true;
            this.renderEntries(this.entries, true);
            return;
        }

        if (!showSelected && !startsWith && !endsWith && filter.length < 3) {
            if (this.filtered) {
                this.filtered = false;
                this.renderEntries(this.entries);
            }
            return;
        }

        this.filtered = true;

        a = this.entries;
        let entriesToShow = [];

        for (i = 0; i < a.length; i++) {
            let entry = a[i];
            let txtValue = this.getTranslatedLabel(entry);

            if ((startsWith && txtValue.toUpperCase().startsWith(filter)) ||
                (endsWith && txtValue.toUpperCase().endsWith(filter)) ||
                (showSelected && this.selectedItems.indexOf(entry.name) >= 0) ||
                (!startsWith && !endsWith && !showSelected && txtValue.toUpperCase().indexOf(filter) > -1)) {
                entriesToShow.push(a[i]);
            } 
        }

        this.renderEntries(entriesToShow);
    }

    renderEntries(entriesToShow, forceEmpty = false) {
        let filter = this.searchInput.value.toUpperCase();
        if (filter.length >= 3 && !this.filtered) {
            this.filterItems();
        }


        this.dropdownItems.innerHTML = "";
      
        let i;

        let fD = this;

         if(this.getBooleanTheme('sortSelectedFirst', true)){
            entriesToShow.sort((a, b) => {
                let aSelected = fD.selectedItems.some(x => x === a.name);
                let bSelected = fD.selectedItems.some(x => x === b.name);
    
                if(aSelected && !bSelected)
                    return -1;
                else if(!aSelected && bSelected)
                    return 1;

                return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
                
            });
        }
     
        let c = 0;

        for (i = 0; i < entriesToShow.length; i++) {
            if (c == this.options.maxItems)
                break;
                
            let entry = entriesToShow[i];
            if(this.allowedEntries !== null && !this.allowedEntries.some(x=> x.name === entry.name)){
                //Given the already selected filters this entry is not allowed to be shown
                
                continue;
            }else if(this.allowedEntries !== null){
                entry = this.allowedEntries.find(x=> x.name === entry.name);
            }
            
            let selected = "";
            if (this.selectedItems.some(x => x === entry.name))
                selected = "selected";

            let count = this.getFilterOptionsNumbers(entry);
            if (selected !== "selected" && count == 0 && this.options.hideEntriesWithZeroResults && !forceEmpty) {
                continue;
            }
            let entryHtml = this.htmlToElement('<a style="padding-top:'+ this.options.itemPaddingTopBottom + 'px; padding-bottom:'+ this.options.itemPaddingTopBottom +'px;" class="dropdown_' + entry.name + ' ' + selected + '" onclick="window[\'' + this.uid + '\'].selectedEntry(\'' + entry.name + '\', this);">' + (this.getTranslatedLabel(entry)) + '<span class="countText"></span></a>');
            this.dropdownItems.appendChild(entryHtml);
            this.setCountForEntry(entry.name, count);

            if(selected === 'selected')
                this.addQuickDeleteForEntry(entry);

            

            c += 1;
        }

        this.updateResults(c);
        this.setTextForDropdown();
        
    }

    renderQuickDeleteForSelected(){
        for (const key in this.selectedItems) {
            if (this.selectedItems.hasOwnProperty(key)) {
                const entryName = this.selectedItems[key];
                let entry = this.entries.filter(x => x.name === entryName)[0];
                if(entry)
                    this.addQuickDeleteForEntry(entry);
            }   
        }
    }

    addQuickDeleteForEntry(entry){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let item = this.quickDeleteAreaElement.querySelector('#qd'+this.uid + entry.name);
        if(item !== null){
            // item.remove();
            if(this.quickDeleteAreaElement.parentElement.classList.contains('hidden') >= 0){
                this.quickDeleteAreaElement.parentElement.classList.remove('hidden');
            }
            return;
           
        }

        item = this.htmlToElement('<div class="quick-delete-item" id="qd'+(this.uid+entry.name)+'" style="padding:'+this.options.quickDeletePadding+'; height:'+this.options.quickDeleteHeight+'px" onclick="window[\'' + this.uid + '\'].removeQuickDeleteForEntryName(\'' + entry.name + '\', this);">'+ (this.getTranslatedLabel(entry)) +'</div>');
        item.dataset.entryName = entry.name;
        item.dataset.uid = this.uid;

        this.quickDeleteAreaElement.appendChild(item);
        if(this.quickDeleteAreaElement.parentElement.classList.contains('hidden') >= 0){
            this.quickDeleteAreaElement.parentElement.classList.remove('hidden');
        }
    }

    removeQuickDeleteForEntryName(entryName){
        let entry = this.entries.filter(x => x.name === entryName)[0];
        this.removeQuickDeleteForEntry(entry);
    }

    removeQuickDeleteForEntry(entry, runSelectedEntry = true){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let item = this.quickDeleteAreaElement.querySelector('#qd'+this.uid + entry.name);
        if(item !== null){
            item.remove();
        }

        if(this.quickDeleteAreaElement.childElementCount == 0){
            if(!this.quickDeleteAreaElement.parentElement.classList.contains('hidden'))
                this.quickDeleteAreaElement.parentElement.classList.add('hidden');
        }

        let element = this.dropdownItems.querySelector('.dropdown_'+entry.name);
        if(runSelectedEntry)
            this.selectedEntry(entry.name, element, false);
    }

    removeQuickDeletes(){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let items = this.quickDeleteAreaElement.querySelectorAll('[id*="qd'+this.uid+'"]');
        if(items !== null){
            items.forEach(i => i.remove());
        }

        if(this.quickDeleteAreaElement.childElementCount == 0){
            if(!this.quickDeleteAreaElement.parentElement.classList.contains('hidden'))
                this.quickDeleteAreaElement.parentElement.classList.add('hidden');
        }
    }

    updateResults(count) {
        if (!this.options.showResults) {
            this.resultsText.innerHTML = '';
            this.resultsText.style.display = 'none';
            return;
        }

        let text = this.getTranslation('filterDropdownResultsText', 'Showing {0} of {1}');
        text = text.replace('{0}', count);
        if(this.allowedEntries == null){
            text = text.replace('{1}', this.entries.length);
        }else{
            text = text.replace('{1}', this.allowedEntries.length);
        }
       

        this.resultsText.innerHTML = text;
        this.resultsText.style.display = 'block';
    }

    setSelectedItems(entryNames) {
        if (!this.options.multiSelect && entryNames.length > 1) {
            entryNames.length = 1;
        }

        this.selectedItems = entryNames;
        this.renderEntries(this.entries);
        this.renderQuickDeleteForSelected();
    }

    setCountForEntry(entryName, count) {
        try{
            let entryHtml = this.dropdownItems.querySelector('.dropdown_' + entryName);
            if (!entryHtml) {
                console.log('ENTRY NOT FOUND');
                return;
            }
            let countSpan = entryHtml.querySelector('.countText');

            if (!this.options.showZeroSelectionCount && count <= 0) {
                countSpan.innerHTML = "";
                return;
            }

            countSpan.innerHTML = ('&nbsp;(' + count + ')');
        } catch(err){
            return;
        }
    }

    setTextForDropdown() {
       let labels = [];
        for (const key in this.selectedItems) {
            if (this.selectedItems.hasOwnProperty(key)) {
                const entryName = this.selectedItems[key];
                let entry = this.entries.filter(x => x.name === entryName)[0];
                if(entry){
                    labels.push(this.getTranslatedLabel(entry));
                }   
            }   
        }

        this.headerDiv.value = labels.toString();
    }

    selectedEntry(entryName, element, removeQuickSelect = true) {
   
        if(!this.options.multiSelect && element == null){
            element = this.dropdownItems.querySelector('.dropdown_'+entryName);
        }

        let toggleValue = !element.classList.contains('selected');
        if (!this.options.multiSelect) {
            this.clearAllSelected(false);
            element.classList.toggle('selected', toggleValue);
        }else{
            element.classList.toggle('selected');
        }
    
        let entry = this.entries.filter(x => x.name === entryName)[0];

        let active = false;
        if (element != null && element.classList.contains('selected')) {
            if (!this.selectedItems.some(x => x === entryName))
                this.selectedItems.push(entry.name);

            active = true;

            this.addQuickDeleteForEntry(entry);
        } else {
            this.selectedItems = this.selectedItems.filter(x => x !== entryName);
            if(removeQuickSelect)
                this.removeQuickDeleteForEntry(entry, false);
        }

        this.setTextForDropdown();

        if(!this.options.multiSelect){
            this.renderEntries(this.entries);

        }

        if(this.getBooleanTheme('closeFilteredTextFieldOnSelect', true))
        {
            this.toggleDropdown();   
        }
        
        if (typeof this.onchange === 'function') {
            this.onchange(entryName, active, element, this);
        }

    }

    clearAllSelected(useCallback) {
        this.selectedItems = [];
        let nodeList = this.dropdownItems.querySelectorAll('a.selected');
        let i;
        for (i = 0; i < nodeList.length; i++) {
            nodeList[i].classList.remove('selected');
        }

        if (useCallback && typeof this.onclearall === 'function') {
            this.onclearall(this);
        }

        this.searchInput.value = "";

        this.renderEntries(this.entries);
        this.setTextForDropdown();
        this.removeQuickDeletes();
    }

    updateEntryCounts(){
        let nodeList = this.dropdownItems.querySelectorAll('a');
        let i;
        for (i = 0; i < nodeList.length; i++) {
            let entryName = Array.from(nodeList[i].classList).find(x=> x !== 'selected');
            let entry = this.entries.find(x => x.name === entryName);
            if(!entry)
                continue;
            let count = this.getFilterOptionsNumbers(entry);
            this.setCountForEntry(entry.name, count);
        }
    }
    getFilterOptionsNumbers(option) {
        if (!window.AtheneumInstance)
            return 0;
      
        if (this.allowedEntries !== null){
            let altOption = this.allowedEntries.find(x=> x.name === option.name);
            if(altOption && altOption.hasOwnProperty('appliedAssets')){
                return altOption.appliedAssets;
            }
        }

        if(option.hasOwnProperty('appliedAssets'))
            return option.appliedAssets;

        let filter = this.filterData;
        let key = filter.name;
        
        let tag = window.AtheneumInstance.Admin.tags?.find(x=> x.name === key);
        if(!tag)
            return 0;

        let tagOpt = tag.options.find(x=> x.name === option.name);
        if(!tagOpt)
            return 0;

        return tagOpt.assetIds?.length || 0;
    }
}
